import { idtype } from "querypieces";

export default `
...on pageBuilder_embedBlock_BlockType {
  ${idtype}
  embed
}
`